import {Optional} from '../../app/TypeHelpers'
import {MESSAGE_TYPE} from '../../CodeMaster'

export class Information {
    messageId: string
    title: Optional<string>
    message: string
    type: MESSAGE_TYPE

    constructor(messageId: string, title: Optional<string>, message: string, type: MESSAGE_TYPE) {
        this.messageId = messageId
        this.title = title
        this.message = message
        this.type = type
    }

    static from(json: any): Information {
        return new Information(
            json.messageId,
            json.title || undefined,
            json.message,
            MESSAGE_TYPE.codeToEnumConstants(json.type) || MESSAGE_TYPE.NOTHING,
        )
    }
}
